<template>
  <div class="tools-partners-invites-sent">
    <snow-data-table-header
      v-if="invitesSent.length"
      :search="false"
      :datePicker="false"
      :filters="false"
      @add="dialog = true"
      addText="Adicionar colaborador"
    />

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <snow-data-table v-else :columns="columns" :data="invitesSent">
      <template #no-content-actions>
        <div class="d-flex flex-column align-items-center text-center gap-4">
          <snow-button
            icon="ph ph-plus"
            text="Enviar um convite"
            @click="dialog = true"
          />
          <h6 class="text-dark-40">
            Convide seus colaboradores para te ajudar a administrar seu negócio
          </h6>
        </div>
      </template>
    </snow-data-table>

    <div v-if="!loading" class="d-flex justify-content-end mt-4">
      <snow-paginator
        v-model="page"
        :pagination="pagination"
        @change-page="dispatch"
      />
    </div>

    <responsive-modal v-model="dialog" size="lg">
      <invite-modal
        v-if="dialog"
        :item="itemToEdit"
        @reload="dispatch"
        @close="dialog = false"
      />
    </responsive-modal>
  </div>
</template>

<script>
import { add, get, transform } from "lodash";
import { mapState } from "vuex";
import InviteModal from "./InviteModal";

export default {
  components: { InviteModal },
  data() {
    return {
      dialog: false,
      loading: false,
      itemToEdit: null,
      page: 1,
      actions: [
        {
          text: "Editar",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        }
      ],
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["invitesSent"]),
    columns() {
      return [
        {
          name: "Usuário",
          field: "name"
        },
        {
          name: "E-mail",
          field: "email"
        },
        {
          name: "Perfil",
          field: "perfil",
          transform: profile => profile.name
        },
        {
          name: "Status",
          field: "is_accepted",
          transform: (_, item) => {
            if (item.accepted_at) return "Aprovado";
            if (item.rejected_at) return "Rejeitado";
            return "Pendente";
          },
          class: (_, item) => this.statusBadge(item)
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
  },
  watch: {
    dialog(v) {
      if (!v) this.itemToEdit = null;
    }
  },
  methods: {
    edit(item) {
      this.itemToEdit = item;
      this.dialog = true;
    },
    profile(item) {
      return item.is_admin ? "Administrador" : get(item, "perfil.name");
    },
    statusBadge(item) {
      if (item.accepted_at) return "active-badge";
      if (item.rejected_at) return "inactive-badge";
      return "draft-badge";
    },
    dispatch(offset) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getInvites", { offset })
        .then(
          ({ count, next, previous }) =>
            (this.pagination = { count, next, previous })
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
